import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { translations } from '../lib/translations';

const LanguageContext = createContext();

export const languages = [
  { code: 'tr', name: 'Türkçe', flag: 'TR' },
  { code: 'en', name: 'English', flag: 'EN' },
  { code: 'de', name: 'Deutsch', flag: 'DE' }
];

// Detect browser language and map to supported languages
function detectBrowserLanguage() {
  // Check localStorage first (user preference)
  const savedLang = localStorage.getItem('datex-language');
  if (savedLang && translations[savedLang]) {
    return savedLang;
  }

  // Get browser language
  const browserLang = navigator.language || navigator.userLanguage || 'en';
  const langCode = browserLang.toLowerCase().split('-')[0]; // 'tr-TR' -> 'tr'

  // Map to supported languages
  if (langCode === 'tr') return 'tr';
  if (langCode === 'de') return 'de';
  return 'en'; // Default to English for all other languages
}

export function LanguageProvider({ children }) {
  const [currentLanguage, setCurrentLanguage] = useState(() => detectBrowserLanguage());

  // Save language preference to localStorage when changed
  useEffect(() => {
    localStorage.setItem('datex-language', currentLanguage);
  }, [currentLanguage]);

  const t = useCallback((key) => {
    const keys = key.split('.');
    let value = translations[currentLanguage];
    
    for (const k of keys) {
      if (value && typeof value === 'object') {
        value = value[k];
      } else {
        return key;
      }
    }
    
    return value || key;
  }, [currentLanguage]);

  const changeLanguage = useCallback((langCode) => {
    if (translations[langCode]) {
      setCurrentLanguage(langCode);
    }
  }, []);

  return (
    <LanguageContext.Provider value={{ 
      currentLanguage, 
      changeLanguage, 
      t,
      languages 
    }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}